import Facebook from '../../src/legacy/Facebook';
export default Facebook;
